<h2 mat-dialog-title class="Dialog-box">
  Update Kit ID
</h2>
<app-loader></app-loader>
<div mat-dialog-content>
  Please enter the new Kit ID below. Please specify a Kit ID that
  has not been previously used.
  <form [formGroup]="dialog" (submit)="Save()">
    <mat-form-field class="SpecimenKitId">
      <input matInput placeholder="New Kit ID" formControlName="SpecimenKitId" required tabindex="-1"
        [maxlength]="maxLengthKit" (focusout)="verifyKitIdRegex()" appMaskKitId appMaskKitId [config]="{
          arrayPos: hyphenPositions,
          arrayLength: selectedKitIdFormat
        }">
        @if (dialog.get('SpecimenKitId').hasError('required')) {
          <mat-error>
            {{ValidationMessages.KITID_MANDATORY}}
          </mat-error>
        }
        @if (dialog.get('SpecimenKitId').hasError('minlength')
          && !dialog.get('SpecimenKitId').hasError('required')) {
          <mat-error>
            {{ValidationMessages.MINIMUM_KIT_ID_LENGTH}}
          </mat-error>
        }
      </mat-form-field>
      @if (kitIdExists && !dialog.get('SpecimenKitId').hasError('required')
        && !dialog.get('SpecimenKitId').hasError('minlength')) {
        <mat-error class="error-placing">{{ValidationMessages.KITDEXISTS}}
        </mat-error>
      }

      @if (kitIdFormatIncorrect && !dialog.get('SpecimenKitId').hasError('minlength')
        && !dialog.get('SpecimenKitId').hasError('required')) {
        <mat-error class="small-font">
          {{ValidationMessages.INCORRECT_KIT_ID_FORMAT}}
        </mat-error>
      }

      <button mat-button color="primary" type="reset" name="reset" (click)="CloseDialog()">Cancel</button>
      <button mat-flat-button color="primary" type="submit" [disabled]="isDisabled()" class="Save-button">Save</button>
    </form>
  </div>